import classNames from 'classnames'

const Title: React.FC<{ className?: string; text: string; desc: string }> = ({
  className,
  text,
  desc,
}) => {
  return (
    <div className={classNames('flex flex-col items-center', className)}>
      <div className="text-[32px] font-semibold text-neutral-50 text-center mb-1 leading-[40px]">
        {text}
      </div>
      <div className="text-[24px] font-semibold text-neutral-600 text-center tracking-[9.6px] uppercase leading-[32px]">
        {desc}
      </div>
      <div
        className="rounded-[32px] w-[64px] h-1 mt-5 mb-4"
        style={{
          background: 'linear-gradient(321deg, #6964DE -10.33%, #FCA6E9 100%)',
        }}
      ></div>
    </div>
  )
}

export default Title
